import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './UnbelievableSummerDeals.css';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import RouterLink from '../atoms/RouterLink';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import getListing from '../../utils/getListing';
import OfferAndDeal from '../102_ListingOffersAndDeals/components/OfferAndDeal';
import Switch from '../Listing/Switch';
import { convertQueryParamsToFacets } from '../Listing';
import { qsToObject } from '../../utils/querystring';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { isNil } from '../../utils/IsNil';
import { checkJssError } from '../../utils/checkJssError';
var getFacetNamesValue = function getFacetNamesValue(filterData) {
  return filterData ? filterData.values.map(function (filter) {
    return get(filter, 'fieldNameItem.item.fieldName.value');
  }) : [];
};
var UnbelievableSummerDealsComponent = function UnbelievableSummerDealsComponent(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var lang = sitecoreContext && sitecoreContext.language || 'en';
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  var location = useLocation();
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    hits = _useState2[0],
    setHits = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    facets = _useState4[0],
    setFacets = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    defaultFacets = _useState6[0],
    setDefaultFacets = _useState6[1];
  var title = get(fields, 'data.listingConfiguration.title.jss.value') || get(fields, 'data.listingConfiguration.name');
  var description = get(fields, 'data.listingConfiguration.shortDescription.jss.value');
  var showMoreButtonText = get(fields, 'data.showMoreButton.title.jss.value');
  var showMoreButtonHref = get(fields, 'data.showMoreButton.link.jss.value.href');
  var currency = get(fields, 'data.listingConfiguration.currency.targetItem.currencyId.jss.value');
  var typeArray = get(fields, 'data.listingConfiguration.contentType.types') || [];
  var filterData = get(fields, 'data.listingConfiguration.filters') || [];
  var filtersArray = get(fields, 'data.listingConfiguration.filters.values') || [];
  var socialSharing = get(fields, 'data.socialSharing');
  var algoliaIndexes = get(params, 'SearchIndex');
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var dictionary = get(fields, 'data.dictionary');
  var bookNowText = getDictionaryItem(dictionary, 'bookNow') || '';
  var expiresSoonText = getDictionaryItem(dictionary, 'expiresSoon') || '';
  var termsAndConditionsText = getDictionaryItem(dictionary, 'termsAndConditions') || '';
  var fromText = getDictionaryItem(dictionary, 'from') || '';
  var offText = getDictionaryItem(dictionary, 'off') || '';
  var ratingTextStars = getDictionaryItem(dictionary, 'stars') || '';
  var queryParams = qsToObject(location.search);
  var facetFilters = convertQueryParamsToFacets(queryParams, true, filterData);
  var analytics = {
    filterAnalytics: eventsAnalytics["callToCategoryAnalytics"],
    params: params
  };
  var _useState7 = useState(function () {
      return canUseDOM ? window.matchMedia("(max-width: 767px)").matches : false;
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    isDesktop = _useState8[0],
    setIsDesktop = _useState8[1];
  var dealRequest = function dealRequest() {
    var types = typeArray.map(function (type) {
      var value = type && type.template.targetItem.value;
      return "type:".concat(value);
    });
    var facetNames = getFacetNamesValue(filterData);
    var itemFilters = {
      facets: _toConsumableArray(facetNames),
      facetFilters: [_toConsumableArray(types)].concat(_toConsumableArray(facetFilters)),
      hitsPerPage: 6
    };
    getListing(algoliaIndexes, itemFilters).then(function (response) {
      setFacets(response.facets);
      setHits(response.hits);
    }).catch(function (error) {
      console.log("error", error);
    });
  };
  useEffect(function () {
    if (canUseDOM) {
      window.addEventListener("resize", function () {
        setIsDesktop(window.matchMedia("(max-width: 767px)").matches);
      });
    }
    return function () {
      if (canUseDOM) {
        window.addEventListener("resize", function () {
          setIsDesktop(window.matchMedia("(max-width: 767px)").matches);
        });
      }
    };
  }, []);
  useEffect(function () {
    var types = typeArray.map(function (type) {
      var value = type && type.template.targetItem.value;
      return "type:".concat(value);
    });
    var facetNames = getFacetNamesValue(filterData);
    var itemFilters = {
      facets: _toConsumableArray(facetNames),
      facetFilters: [_toConsumableArray(types)],
      hitsPerPage: 1
    };
    getListing(algoliaIndexes, itemFilters).then(function (response) {
      setDefaultFacets(response.facets);
    });
  }, []);
  useEffect(function () {
    dealRequest();
  }, [location.search]);
  var renderItems = function renderItems() {
    if (!hits.length) {
      return [];
    }
    return hits.map(function (deal) {
      return /*#__PURE__*/React.createElement(OfferAndDeal, {
        key: deal.objectID,
        fromText: fromText,
        offText: offText,
        expiresSoonText: expiresSoonText,
        bookNowText: bookNowText,
        termsAndConditionsText: termsAndConditionsText,
        deal: deal,
        rtl: rtl,
        currency: currency,
        gridMode: false,
        socialSharing: socialSharing,
        eventsAnalytics: eventsAnalytics,
        params: params,
        ratingTextStars: ratingTextStars,
        isSwipeable: false,
        isDraggable: false
      });
    });
  };
  if (isNil(fields) || isNil(fields.data)) {
    console.info('UnbelievableSummerDeals component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [UnbelievableSummerDeals component is empty: please provide data source]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("p", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, description), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CarouselProvider, {
    isSwipeableBeforeChange: true
  }, function (_ref2) {
    var renderCarousel = _ref2.renderCarousel,
      renderPreviousButton = _ref2.renderPreviousButton,
      renderNextButton = _ref2.renderNextButton,
      renderDots = _ref2.renderDots,
      moveToSlide = _ref2.moveToSlide;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "switchWithBtnGroup"
    }, filtersArray && filtersArray.map(function (filter, index) {
      var fieldTypeItem = get(filter, 'fieldTypeItem.item.fieldType.value');
      var fieldNameItem = get(filter, 'fieldNameItem.item.fieldName.value');
      var itemfacets;
      var defaultItemFacets;
      if (facets && defaultFacets) {
        itemfacets = facets[fieldNameItem] || facets[fieldNameItem + 'RangeIndex'];
        defaultItemFacets = defaultFacets[fieldNameItem] || defaultFacets[fieldNameItem + 'RangeIndex'];
      }
      if (fieldTypeItem === 'Toggle Single Select') {
        return /*#__PURE__*/React.createElement(Switch, {
          fields: filter,
          facets: itemfacets,
          defaultFacets: defaultItemFacets,
          facetsName: fieldNameItem,
          firstQuery: facetFilters.length !== 0 ? facetFilters[facetFilters.length - 1][0].split(':')[0] : '',
          setFilter: function setFilter() {
            moveToSlide(0);
          },
          clearAlllFilters: false,
          isTagPage: false,
          dictionary: dictionary,
          firstFilter: true,
          analytics: analytics,
          getFilterValue: function getFilterValue() {
            return null;
          },
          rtl: rtl,
          resetAllFiltersCallback: function resetAllFiltersCallback() {
            return null;
          },
          autoWidth: true,
          summerDeals24: true,
          key: index
        });
      } else {
        return /*#__PURE__*/React.createElement("div", {
          key: index
        });
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "btn-group"
    }, renderPreviousButton(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['callToPrevAnalytics'], params));
    }), renderNextButton(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['callToNextAnalytics'], params));
    }))), renderCarousel(renderItems(), {
      responsive: {
        extra: {
          breakpoint: {
            max: 10000,
            min: 1601
          },
          items: 4
        },
        desktop: {
          breakpoint: {
            max: 1600,
            min: 901
          },
          items: 3
        },
        tablet: {
          breakpoint: {
            max: 900,
            min: 701
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 700,
            min: 0
          },
          items: 1
        }
      },
      containerClass: "carouselContainer"
    }), !hits.length ? /*#__PURE__*/React.createElement("p", {
      style: {
        fontSize: "36px",
        fontWeight: "600",
        marginBottom: "50px"
      }
    }, "no deals available") : null, /*#__PURE__*/React.createElement("div", {
      className: "paginationDot"
    }, renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['callToBubblesAnalytics'], params));
    })), showMoreButtonText && showMoreButtonHref ? /*#__PURE__*/React.createElement("div", {
      className: "ctaButton",
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['callToMoreDealsAnalytics'], params), [title, showMoreButtonText]);
      }
    }, isDesktop ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
      href: showMoreButtonHref,
      "aria-label": "Show More",
      className: "btn btn-primary"
    }, showMoreButtonText)) : /*#__PURE__*/React.createElement(RouterLink, {
      className: "btn-tertiary",
      href: showMoreButtonHref,
      linktype: "external",
      openInSameTab: true
    }, /*#__PURE__*/React.createElement("span", {
      className: "btn-tertiary__text"
    }, showMoreButtonText), /*#__PURE__*/React.createElement(ChevronLeft, {
      className: "ctaChevron"
    }))) : null);
  })));
};
var UnbelievableSummerDeals = function UnbelievableSummerDeals(props) {
  return checkJssError(props, UnbelievableSummerDealsComponent);
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c1r5r7fs";
var rtlStyles = "r1849wm9";
var ltrStyles = "l1ptt8n8";
export default UnbelievableSummerDeals;